/**
 * One welcome per entry into a reader.
 *
 * Entering a reader runs two things that each ask the backend to "welcome"
 * the session: start_session (via loadReaderDoorman) and the entry loader
 * that follows it. Welcoming re-runs the state's start_state on the backend.
 * For the Doorman menu that is harmless. For a Care Package door session it
 * is not: the first welcome opens the interview from the gift's topic, and a
 * second welcome talks over it, replacing the topic chips with the plain
 * interview (share-door e2e, 2026-09-21).
 *
 * The relay lets the first caller record what its welcome returned and the
 * second take it once, instead of welcoming the same session again. A plain
 * closure so it is unit-testable without mounting the page.
 */
export function createWelcomeRelay() {
  let pending = null
  return {
    // loadReaderDoorman records its welcome's result. An empty menu ([]) still
    // counts as welcomed — record it as [] so the next caller does not re-ask.
    record(actions) { pending = actions == null ? [] : actions },
    // True when a welcome is waiting to be reused (vs. nothing recorded, so
    // the caller must welcome the session itself).
    get hasPending() { return pending !== null },
    // The recorded welcome, once. Reading it clears it, so a later entry that
    // records nothing falls through to a fresh welcome rather than reusing a
    // stale one.
    take() { const v = pending; pending = null; return v },
  }
}

/**
 * A Care Package arrival: the door reloads to ?gift=1, so the recipient should
 * land in the room with the opener open, not on the profile with the chat
 * folded away. Read once, then the flag is dropped from the URL.
 */
export function isGiftArrival(query) {
  return !!(query && query.gift)
}
